import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { MdEdit, MdLink } from "react-icons/md";
import Cookies from "js-cookie";
import Loadinggrid from "../components_root/loading";
import demowallpaper from "../assets/editer_imgs/demowallpaper.jpg";
import HomeSlideshow from "../page_root/homeslideshow";
import { VscChevronRight } from "react-icons/vsc";
import {
    getDocs,
    query,
    collection,
    where,
    orderBy, onSnapshot
} from "firebase/firestore";
import { db } from "../firebase";

import { Toast } from "../components_root/ToastContext";

export const seo = {
    title: "Online Tools & Digital Services | Productivity, SEO & File Conversion",
    description:
        "Explore free and premium online tools including word counters, file converters, favicon generators, SEO analyzers, and text utilities.",
    keywords:
        "online tools, productivity tools, seo tools, file converter, word counter"
};
export default function Index() {
    const { Toastshow } = Toast();
    const navigate = useNavigate();

    const [pageuid, setpageuid] = useState();
    const [page_name, setpage_name] = useState("");
    const [page_title, setpage_title] = useState("");
    const [page_description, setpage_description] = useState("");
    const [page_keywords, setpage_keywords] = useState("");
    const [page_editdata, setPage_editdata] = useState([]);
    const [loading, setLoading] = useState(true);
    //
    const [pluginsdata, setpluginsdata] = useState([]);

    const [companyuid] = useState(Cookies.get("website_company_uid"));

    //slide file 
    const [contentdata, setcontentdata] = useState([]);
    // ================= fetch_pagesData =================
    useEffect(() => {
        const fetch_pagesData = async () => {
            try {
                if (!companyuid) return;
                setLoading(true);
                const companySnap = await getDocs(
                    query(
                        collection(db, "companies", companyuid, "pages"),
                        where("slug", "==", "home"),
                        where("status", "==", true)
                    )
                );
                if (!companySnap.empty) {
                    const data = companySnap.docs.map(doc => ({
                        ...doc.data(),
                        uid: doc.id
                    }));
                    const first = data[0] || {};
                    // ✅ SAFE SET
                    setpageuid(first.pageuid);
                    setpage_name(first.page_name || "");
                    setpage_title(data[0].page_title);
                    setpage_description(first.page_description || "");
                    setpage_keywords(first.page_keywords || "");
                    setPage_editdata(data);
                } else {
                    setPage_editdata([]);
                }
            } catch (err) {
                console.error("Error:", err);
                Toastshow("Failed to load data");
            } finally {
                setLoading(false);
            }
        };


        fetch_pagesData();
    }, [companyuid]);

    //fetch_pluginsData
    useEffect(() => {
        const fetch_pluginsData = async () => {
            try {
                if (!companyuid || !pageuid) return; // ✅ FIX

                setLoading(true);

                const pluginsRef = collection(
                    db,
                    "companies",
                    companyuid,
                    "pages",
                    pageuid,
                    "plugins"
                )

                //  
                const companySnap = await getDocs(pluginsRef, where("status", "==", true), orderBy("indexnumber", "asc"));

                if (!companySnap.empty) {
                    const data = companySnap.docs.map(doc => ({
                        ...doc.data(),
                        uid: doc.id
                    }));

                    setpluginsdata(data);
                } else {
                    setpluginsdata([]);
                }

            } catch (err) {
                console.error("Error:", err);
                Toastshow("Failed to load pluginsdata");
            } finally {
                setLoading(false);
            }
        };
        fetch_pluginsData();
    }, [companyuid, pageuid]);
    //get home_silde contentdata
    useEffect(() => {
        if (!companyuid || !pageuid) return;

        setLoading(true);

        const ref = collection(
            db,
            "companies",
            companyuid,
            "pages",
            pageuid,
            "contentdata"
        );
        const q = query(
            ref,
            where("status", "==", true),
            orderBy("indexnumber", "asc")
        );

        const unsubscribe = onSnapshot(
            q,
            (snapshot) => {
                if (snapshot.empty) {
                    setcontentdata([]);
                    setLoading(false);
                    return;
                }

                const data = snapshot.docs.map((doc) => ({
                    ...doc.data(),
                    uid: doc.id
                }));

                setcontentdata(data);
                setLoading(false);
            },
            (err) => {
                console.error("❌ Firestore Error:", err);
                Toastshow("Failed to load content");
                setLoading(false);
            }
        );

        return () => unsubscribe();

    }, [companyuid, pageuid]);
    return (
        <div>
            <Helmet>
                <title>{page_title || seo.title}</title>
                <meta name="description" content={page_description || seo.description} />
                <meta name="keywords" content={page_keywords || seo.keywords} />
                <meta property="og:title" content={page_name || seo.title} />
                <meta property="og:description" content={page_description || seo.description} />
            </Helmet>

            {/* Content */}
            <div className="container_roots">
                <div className="ui-grid-fill">
                    {loading ? (
                        <Loadinggrid />
                    ) : pluginsdata.length === 0 ? (
                        <Loadinggrid />
                    ) : (
                        pluginsdata.map((item) => (
                            <>
                                {/* Slideshow*/}
                                {item.pluguid === "rBCnU6XMGG" && (
                                    <div key={item.uid}  >

                                        {contentdata?.length > 0 && (
                                            <HomeSlideshow
                                                slideshow_filedata={
                                                    contentdata.filter(item => item.pluguid === "rBCnU6XMGG")
                                                }
                                                banner_default={demowallpaper}
                                            />
                                        )}
                                    </div>
                                )}

                                {/* Text */}
                                {item.pluguid === "Pg7cY0Q1jl" && (
                                 <div className="container_size"> 
                                 
                                    <div className="post-container mtop" key={item.uid}>

                                        <div className="post_div">
                                            {contentdata
                                                ?.find((row) => row.pluguid === "Pg7cY0Q1jl")
                                                ?.description && (
                                                    <div
                                                        dangerouslySetInnerHTML={{
                                                            __html: contentdata.find(
                                                                (row) => row.pluguid === "Pg7cY0Q1jl"
                                                            ).description,
                                                        }}
                                                    />
                                                )}
                                        </div>

                                        {pluginsdata
                                            ?.find(p => p.pluguid === "UwRQEKVnx0") && (
                                                <div className="post_updates">

                                                    <table>
                                                        <tr>
                                                            <td>
                                                                <div className="bold">
                                                                    {pluginsdata.find(p => p.pluguid === "UwRQEKVnx0")?.plugins_name || "Untitled"}
                                                                </div>
                                                            </td>

                                                        </tr>

                                                    </table>

                                                    <div className="ui-guid">
                                                        {contentdata?.length > 0 &&

                                                            contentdata.filter(item => item.pluguid === "UwRQEKVnx0")
                                                                .map((row, index) => (
                                                                    <div className="ui-items b-1 rounded p-1" key={index}>
                                                                        <table>
                                                                            <tr className="cursor " onClick={() => {
                                                                                if (row.linkurl) {
                                                                                    if (row.linkurl.startsWith("http")) {
                                                                                        // external link
                                                                                        window.open(row.linkurl, "_blank");
                                                                                    } else {
                                                                                        // internal route
                                                                                        navigate(row.linkurl);
                                                                                    }
                                                                                }
                                                                            }}>
                                                                                <td width={20}><MdLink /></td>
                                                                                <td className="bold fcap u-hover">
                                                                                    <a href={row.linkurl}>{row.linkurl}</a>
                                                                                </td>

                                                                                <td width={20}><VscChevronRight /></td>
                                                                            </tr>
                                                                        </table>

                                                                    </div>
                                                                ))
                                                        }

                                                    </div>
                                                </div>
                                            )}

                                    </div>
                                    </div>
                                )}


                                {/* Gallery*/}
                                {item.pluguid === "CCmMD23uB3" && (
                                    <div key={item.uid} className="m-top">


                                        <div className="bold">
                                            {item.plugins_name || "Untitled"}
                                        </div>
                                        <div className="bold">
                                            {item.pluguid || "Untitled"}
                                        </div>


                                    </div>
                                )}


                                {/* Download */}
                                {item.pluguid === "3mPZGgUnGt" && (
                                    <div key={item.uid} className="m-top">


                                        <div className="bold">
                                            {item.plugins_name || "Untitled"}
                                        </div>
                                        <div className="bold">
                                            {item.pluguid || "Untitled"}
                                        </div>


                                    </div>
                                )}

                            </>
                        ))
                    )}


                </div>
            </div>
        </div>
    );
}